export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            // type: "configue",
        },
        {
            title: "College",
            value: "college",
            // type: "configue",
        },
        {
            title: "Admission Number",
            value: "admissionNumber",
            // type: "configue",
        },
        {
            title: "Live Class URL",
            value: "liveClassUrl",
            // type: "configue",
        },
        {
            title:"Recorded URL",
            value: "recordedUrls",
            // type: "configue"
        },
        {
            title:"Meeting Title",
            value: "name",
            // type: "configue"
        },
        {
            title: "Recorded Video Max Visible Date",
            value: "recordedVideoMaxVisibleDate",
            // type: "configue",
            name: "recordedVideoMaxVisibleDate"
        },
        {
            title: "Package Name",
            value: "packageName",
            // type: "configue",
        },
        {
            title: "Duration",
            value: "duration",
            // type: "configue",
        },

        {
            title: "Live Date Time",
            value: "liveDateTime",
            // type: "configue",
            name: "liveDateTime"
        }, 
        {
            title: "MarkedAsDeleted",
            value: "markAsDeleted",
            // type: "configue"
        },
        {
            title: "Status Actions",
            value: "statusActions",
            // type: "configue"
        } 
    ],
    secondaryData: [
        {
            title: "Batch",
            value: "batch",
            // type: "configue",
        },
        {
            title: "Sub Batch",
            value: "subBatch",
            // type: "configue",
        },
        {
            title: "Subject",
            value: "subject",
            // type: "configue",
        },
        {
            title: "Department",
            value: "department",
            // type: "configue",
        },
        {
            title: "Designation",
            value: "designation",
            // type: "configue",
        },
        {
            title: "Created At",
            value: "createdAt",
            // type: "configue",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            // type: "configue",
            name: "updatedAt"
        },
    ],
};